<div class="d-flex align-items-center justify-content-center" style="height: 100vh; width: 100vw">
  <div class="login-form-bg pb-5">
    <div class="d-flex justify-content-center form-title py-3" style="width: 100%">
      <p class="fs-4 mb-0 text-black">Forget Password</p>
    </div>
    <form nz-form [formGroup]="forgetVerifyForm" class="login-form" (ngSubmit)="submitForm()">
      <nz-form-item class="mb-2">
        <div class="w-100">
          <nz-form-label nzRequired>Mobile Number</nz-form-label>
          <nz-form-control nzErrorTip="Please input Mobile Number!">
            <nz-input-group nzPrefixIcon="phone">
              <input type="text" nz-input formControlName="mobileNumber" placeholder="Mobile Number" />
            </nz-input-group>
          </nz-form-control>
        </div>
      </nz-form-item>
      <nz-form-item class="mb-2">
        <div class="w-100">
          <nz-form-label nzRequired>OTP</nz-form-label>
          <nz-form-control nzErrorTip="Please input OTP!">
            <nz-input-group nzPrefixIcon="safety">
              <input type="text" nz-input formControlName="otp" placeholder="OTP" />
            </nz-input-group>
          </nz-form-control>
        </div>
      </nz-form-item>
      <nz-form-item class="mb-2">
        <div class="w-100">
          <nz-form-label nzRequired>Password</nz-form-label>
          <nz-form-control nzErrorTip="Please input your Password!">
            <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplate">
              <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password"
                placeholder="Password" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" nzTheme="outline"
              (click)="passwordVisible = !passwordVisible"></i>
            </ng-template>
          </nz-form-control>
        </div>
      </nz-form-item>
      <nz-form-item class="mb-2">
        <div class="w-100">
          <nz-form-label nzRequired>Confirm Password</nz-form-label>
          <nz-form-control [nzErrorTip]="errorTpl">
            <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplateC">
              <input [type]="confirmPasswordVisible ? 'text' : 'password'" nz-input [formControl]="confirmPassword"
                autocomplete="false" placeholder="Confirm Password" />
              <ng-template #errorTpl let-control>
                @if (control.hasError('required')) {
                  Please confirm your password!
                }
                @if (control.hasError('confirm')) {
                  Two passwords that you enter is inconsistent!
                }
              </ng-template>
              <ng-template #suffixTemplateC>
                <i nz-icon [nzType]="confirmPasswordVisible ? 'eye-invisible' : 'eye'" nzTheme="outline"
                (click)="confirmPasswordVisible = !confirmPasswordVisible"></i>
              </ng-template>
            </nz-input-group>
          </nz-form-control>
        </div>
      </nz-form-item>
      <button nz-button class="login-form-button mt-2 w-100" [nzType]="'primary'">
        Update
      </button>
    </form>
  </div>
</div>
